<template>
	<div class="eia-home">
		<div>
			<eia-heading level="h1">
				Run a check to see if your development site requires Environmental Impact Assessment
			</eia-heading>

			<eia-paragraph>
				Use this simple service to get an automated response to find out if your proposed development triggers the potential need for Environmental Impact Assessment (EIA) and if EIA Screening is required.
			</eia-paragraph>
			<eia-paragraph>
				This tool currently applies to locations in England and Wales only.
			</eia-paragraph>
		</div>

		<div class="eia-home__tips">
			<eia-well>
				<eia-heading level="h4">
					What you need to hand to complete and submit this form
				</eia-heading>

				<eia-ordered-list>
					<eia-list-item>Location</eia-list-item>
					<eia-list-item>What you're proposing (footprint, size, uses)</eia-list-item>
				</eia-ordered-list>
			</eia-well>

			<eia-well>
				<eia-heading level="h4">
					How long it takes
				</eia-heading>

				<eia-paragraph>
					The process involves answering a small number of basic Yes/No questions – this should take no longer than 1-2 minutes to complete. A result will be generated automatically along with recommendations for next steps, and a summary will be provided to you.
				</eia-paragraph>
			</eia-well>
		</div>

		<!-- <eia-map></eia-map> -->

		<eia-button
			variation="primary"
			size="large"
			:path="firstStagePath">
			Start Now
		</eia-button>
	</div>
</template>

<script>
// import stageRoutes from '@/router/stages';

const defaultState = {
	selectedProposal: '',
	customProposal: '',
	customProposalError: null,
	customProposalVisible: false,
};

export default {
	name: 'Home',

	data() {
		return {

		};
	},

	computed: {
		firstStagePath() {
			this.reset();

			return { path:'/proposal' };
		},
	},

	methods: {

		reset(){

			this.$store.commit( 'stages/reset' );

			for( const key of Object.keys( defaultState ) ){
				this[ key ] = defaultState[ key ];
			}

		},
	},
};
</script>

<style lang="scss" scoped>
.eia-home {
	&__tips {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 24px;
		margin-bottom: 24px;

		@media screen and (max-width: $screen-xs) {
			grid-template-columns: 1fr;
			grid-gap: 0;
		}
	}
}
</style>
